





















































































































































import { defineComponent, computed, ref } from '@vue/composition-api';
import store from '@/store';
import { snackbar } from '@/components/GlobalSnackbar';

export default defineComponent({
  name: 'UploadProgressDisplay',
  setup() {
    const uploads = computed(() => store.state.upload.uploads);
    const allSuccessful = computed(() => store.getters.upload.allSuccessful);
    const inProgress = computed(() => store.state.upload.inProgress);
    const dialogOpen = computed(() => store.state.upload.dialogOpen);
    const totalProgress = computed(() => store.getters.upload.totalProgress);
    const minimized = ref(false);
    const closeDialogDialog = ref(false);

    function closeDialog() {
      store.commit.upload.setDialogOpen(false);
      closeDialogDialog.value = false;
    }

    function cancelUpload(index: number) {
      store.dispatch.upload.cancelUpload(index);
    }

    async function cancelAllUploads() {
      await store.dispatch.upload.cancelAllUploads();
      snackbar.dispatch({ text: 'Uploads Cancelled.' });

      closeDialog();
    }

    function handleClickClose() {
      if (!inProgress.value) {
        closeDialog();
      } else {
        closeDialogDialog.value = true;
      }
    }

    return {
      uploads,
      allSuccessful,
      inProgress,
      totalProgress,
      dialogOpen,
      closeDialog,
      closeDialogDialog,
      handleClickClose,
      cancelUpload,
      cancelAllUploads,
      minimized,
    };
  },
});
